
import clsx from 'clsx';
import styles from './Tab.module.scss';

interface TabProps {
  label: string;
  control: string;
  selected: boolean;
  onClick: (event: React.SyntheticEvent, newValue: string) => void;
}

export const Tab = ({ label, onClick, control, selected }: TabProps) => {
  return (
    <button
      onClick={(e) => {
        onClick(e, control);
      }}
      role="tab"
      aria-selected={selected}
      aria-controls={control}
      className={clsx(styles.tab, { [styles.active]: selected })}
    >
      {label}
    </button>
  );
};
